// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Help = function Help(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 .831A7.169 7.169 0 1015.169 8 7.169 7.169 0 008 .831zm-.4 12.023a.979.979 0 11.979-.979.979.979 0 01-.979.979zm3.039-6.544a2.474 2.474 0 01-.43.72 6.932 6.932 0 01-.992.892 3.8 3.8 0 00-.8.782 1.5 1.5 0 00-.2.833v.291H6.944v-.413A2.439 2.439 0 017.2 8.232a3.371 3.371 0 01.9-.976 5 5 0 001-.942 1.415 1.415 0 00.223-.8 1.007 1.007 0 00-.362-.833 1.625 1.625 0 00-1.04-.291 3.57 3.57 0 00-1.137.175 8.062 8.062 0 00-1.021.42l-.544-1.139a5.686 5.686 0 012.81-.73 3.038 3.038 0 012.009.62 2.11 2.11 0 01.743 1.712 2.438 2.438 0 01-.142.862z"
    }))
  );
};

export default Help;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Help.js
// module id = 1021
// module chunks = 0